<template>
  <div class="document-upload">
    <slot name="step-summary" />

    <ul class="mt-30 pl-4">
      <li
        v-for="(rule, index) in rules"
        :key="index"
        class="list-disc my-10"
      >
        {{ rule }}
      </li>
    </ul>

    <div class="mt-6 sm:mt-45">
      <AppFileInput
        v-for="(button, index) in uploadButtons"
        :key="index"
        :value="button.value"
        :error="button.error"
        :document-type="button.documentType"
        :no-file-chosen-text="button.noFileChosenText"
        :required="button.required"
        class="document-upload__input"
        :docs-stand-alone="docsStandAlone"
        :theme="theme"
        @input="$_input_updateState(button.vuexActionFile, $event)"
        @upload-success="uploadSuccess(button.vuexAction, button.dataLayerEvent)"
        @upload-failed="uploadModalOpen = true"
      >
        <template #icon>
          <FontAwesomeIcon
            icon="camera"
            class="mr-15 text-lg"
          />
          {{ button.title }}
        </template>
      </AppFileInput>
    </div>

    <section
      v-if="uploadModalOpen && showSkipModal"
      class="fixed top-0 left-0 z-30 bg-black/40 w-screen h-screen flex items-center justify-center"
      @click.self="uploadModalOpen = false"
    >
      <div
        class="relative flex flex-col text-center bg-white rounded-8 px-40 py-16 gap-4 w-full max-w-[358px]"
      >
        <p class="font-semibold text-lg leading-[28px]">
          Having trouble <br> uploading files?
        </p>
        <FontAwesomeIcon
          icon="xmark"
          class="absolute top-3 right-[14px] text-xl text-red-500 mb-4 cursor-pointer"
          @click="uploadModalOpen = false"
        />
        <p>If you’re running into issues, you can<br> skip this step for now.</p>

        <AppUploadButton
          :theme="theme"
          centered
          @click="$emit('skip')"
        >
          Skip Upload
        </AppUploadButton>
      </div>
    </section>
  </div>
</template>

<script>
import AppFileInput from '@/components/common/inputs/AppFileInput'
import DataLayer from '@/utilities/data-layer'
import input from '@/mixins/input'
import AppUploadButton from '@/components/common/buttons/AppUploadButton'

export default {
  name: 'DocumentUpload',

  components: {
    AppFileInput,
    AppUploadButton
  },

  mixins: [
    input
  ],

  props: {
    error: {
      type: String,
      default: ''
    },

    rules: {
      type: Array,
      default: () => []
    },

    uploadButtons: {
      type: Array,
      default: () => []
    },

    docsStandAlone: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'green'
    },

    showSkipModal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      uploadModalOpen: false
    }
  },

  methods: {
    uploadSuccess (vuexAction, dataLayerEvent) {
      if (dataLayerEvent) DataLayer.pushObject(dataLayerEvent)
      this.$_input_updateState(vuexAction, true)
      this.uploadModalOpen = false
    }
  }
}
</script>

<style lang='scss' scoped>
.document-upload__input {
  @apply mb-45;

  &:last-child {
    @apply mb-0;
  }
}
</style>
